import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_react_colorful_56406a63__ from "react-colorful";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__ from "./popover.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__input_mjs_9e13df5e__ from "./input.mjs";
const ColorPicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(({ disabled, value, onChange, onBlur, name, className, size = "default", circular }, forwardedRef)=>{
    const ref = (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.useForwardedRef)(forwardedRef);
    const [open, setOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const parsedValue = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>value.toUpperCase() || "#FFFFFF", [
        value
    ]);
    const getSizeClasses = ()=>{
        switch(size){
            case "sm":
                return "tw-h-8 tw-w-8 tw-text-xs";
            case "lg":
                return "tw-h-10 tw-w-10";
            case "default":
                return "tw-h-9 tw-w-9";
            default:
                return size || "tw-h-9 tw-w-9";
        }
    };
    const baseClasses = (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-inline-flex tw-items-center tw-justify-center tw-transition-colors", "tw-border tw-border-input tw-bg-white tw-shadow-sm", "hover:tw-bg-accent hover:tw-text-accent-foreground", "focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring", "disabled:tw-pointer-events-none disabled:tw-opacity-50", getSizeClasses(), circular ? "tw-rounded-full tw-aspect-square tw-p-0" : "tw-rounded-md", className);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
        onOpenChange: setOpen,
        open: open,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
                asChild: true,
                disabled: disabled,
                onBlur: onBlur,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("button", {
                    className: baseClasses,
                    name: name,
                    onClick: ()=>{
                        setOpen(true);
                    },
                    disabled: disabled,
                    style: {
                        backgroundColor: parsedValue
                    },
                    type: "button",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {})
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
                className: "tw-w-full",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_colorful_56406a63__.HexColorPicker, {
                        color: parsedValue,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__input_mjs_9e13df5e__.Input, {
                        maxLength: 7,
                        onChange: (e)=>{
                            var _e_currentTarget;
                            onChange(null == e ? void 0 : null === (_e_currentTarget = e.currentTarget) || void 0 === _e_currentTarget ? void 0 : _e_currentTarget.value);
                        },
                        ref: ref,
                        value: parsedValue
                    })
                ]
            })
        ]
    });
});
ColorPicker.displayName = "ColorPicker";
export { ColorPicker };

//# sourceMappingURL=color-picker.mjs.map